<template>
  <div class="card bg-light d-flex flex-fill">
    <div class="card-header titulos-conteudo mb-2">{{camposConvite.f_summary}}</div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-12">
          <span>
            <small class="text-muted">Início: {{formatarDataHora(camposConvite.f_dtstart)}}</small>
            <br/>
            <small class="text-muted">Término: {{formatarDataHora(camposConvite.f_dtend)}}</small>
            <br/>
            <small class="text-muted">Local: {{camposConvite.f_location}}</small>
            <br/>
            <small class="text-muted">Status: {{getStatus(camposConvite.f_status)}}</small>
          </span>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="text-right">
        <b-button class="botoes" variant="outline-success btn-sm mr-1" @click="obterRetornoConvitePendente(camposConvite, true)" :disabled="desabilitar">Aceitar</b-button>
        <b-button class="botoes" variant="outline-danger btn-sm mr-1" @click="obterRetornoConvitePendente(camposConvite, false)" :disabled="desabilitar">Negar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/util/constants'
import util from '@/util'

export default {
  name: 'convitesPendentes',
  components: {},

  props: {
    camposConvite: [Object],
    desabilitar: Boolean
  },

  data: () => {
    return {
      flagsDeControle: {
        carregandoDados: {
          convites: {
            status: false
          }
        },
        manipulandoDados: {
          convites: {
            status: false
          }
        }
      }
    }
  },

  methods: {
    obterRetornoConvitePendente (camposConvite, retorno) {
      const convite = {
        'f_id': camposConvite.f_id,
        'f_event': camposConvite.f_event,
        'f_status': retorno === true ? constants.statusConvites.aceito : constants.statusConvites.rejeitado
      }
      let parametrosRequisicao = {
        convites: [convite]
      }
      this.$emit('retornoDoConvite', parametrosRequisicao)
    },

    getStatus (value) {
      switch (value) {
        case 1:
          return constants.statusConvites.pendenteLabel
        case 2:
          return constants.statusConvites.aceitoLabel
        case 3:
          return constants.statusConvites.rejeitadoLabel
      }
    },

    formatarDataHora (data) {
      let dataFormatada = util.formatarData(data, 'DD/MM/YYYY HH:mm')
      return dataFormatada
    }
  }
}
</script>

<style scoped>
@import "./scss/inicio.scss";
</style>
